var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModelingLocateAlignNetworkSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009ad9;}.cls-2{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ModelingLocateAlignNetwork_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,15a3.28,3.28,0,0,0-3.28,3.28C14.72,21,18,24.35,18,24.35s3.28-3.4,3.28-6.07A3.28,3.28,0,0,0,18,15Zm0,4.77a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,18,19.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11,19.28V8.7a2,2,0,0,0-.26-3.55A1.85,1.85,0,0,0,10,5a2,2,0,0,0-1.27.46,2,2,0,0,0,0,3.08L9,8.72V19.3a2,2,0,0,0,.26,3.55A1.85,1.85,0,0,0,10,23a2,2,0,0,0,1.27-.46,2,2,0,0,0,0-3.08A2.11,2.11,0,0,0,11,19.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22,25a2,2,0,0,0-1.72,1H16a5,5,0,0,1-4.3-2.53A3,3,0,0,1,10,24c-.11,0-.22,0-.33,0A7,7,0,0,0,16,28h4.28A2,2,0,0,0,22,29a2,2,0,0,0,0-4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelingLocateAlignNetworkSvg);
export default __webpack_public_path__ + "static/media/ModelingLocateAlignNetwork_svg.f0b675d8253dfc033bb512e1ac8be35a.svg";
export { ForwardRef as ReactComponent };